// src/hooks/useCreditPricing.ts
// Leest actuele credit-prijzen uit credit_pricing (publiek leesbaar via RLS)
// zodat knoppen vooraf kunnen tonen wat een actie kost.
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface CreditPricing {
  pricing: Record<string, number>;
  isLoading: boolean;
}

// Fallbacks voor als de fetch faalt; gelijk aan de actuele DB-waarden.
const FALLBACK_PRICING: Record<string, number> = {
  images_generate: 400,
  email_campaign_send: 100,
};

export function useCreditPricing(): CreditPricing {
  const [state, setState] = useState<CreditPricing>({
    pricing: FALLBACK_PRICING,
    isLoading: true,
  });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const { data, error } = await supabase
        .from('credit_pricing')
        .select('action_type, credits_cost')
        .eq('is_active', true);

      if (cancelled) return;
      if (error || !data) {
        console.error('Error loading credit pricing:', error);
        setState({ pricing: FALLBACK_PRICING, isLoading: false });
        return;
      }
      const pricing: Record<string, number> = { ...FALLBACK_PRICING };
      for (const row of data) pricing[row.action_type] = row.credits_cost;
      setState({ pricing, isLoading: false });
    }

    load();
    return () => { cancelled = true; };
  }, []);

  return state;
}
